<template>
  <div class="service-content">
    <p v-if="debug">Loading Service: {{ $route.params.serviceId }}</p>
  </div>
</template>

<script setup lang="ts">
const debug = true;
</script>

<style scoped>
.service-content { width: 100%; height: 100%; }
</style>